import { UIIcon } from "@dropbox/dig-icons";
import { TargetLine } from "@dropbox/dig-icons/dist/mjs/assets";
import classNames from "classnames";
import styles from "./RelevanceRating.module.css";
import { Rating } from "./rating";

export default function RelevanceRatingIcon({
  rating,
}: {
  rating?: Rating | null;
}) {
  return (
    <UIIcon
      className={classNames(rating && styles[`rating-${rating}`])}
      size="small"
      src={TargetLine}
    />
  );
}
